<template>
  <ul class="Editor-Smiles-List" @click="chooseSmile">
    <li class="Editor-Smiles-List__item">💌</li>
    <li class="Editor-Smiles-List__item">🕳️</li>
    <li class="Editor-Smiles-List__item">💣</li>
    <li class="Editor-Smiles-List__item">🛀</li>
    <li class="Editor-Smiles-List__item">🛌</li>
    <li class="Editor-Smiles-List__item">🔪</li>
    <li class="Editor-Smiles-List__item">🏺</li>
    <li class="Editor-Smiles-List__item">🗺️</li>
    <li class="Editor-Smiles-List__item">🧭</li>
    <li class="Editor-Smiles-List__item">🧱</li>
    <li class="Editor-Smiles-List__item">💈</li>
    <li class="Editor-Smiles-List__item">🦽</li>
    <li class="Editor-Smiles-List__item">🦼</li>
    <li class="Editor-Smiles-List__item">🛢️</li>
    <li class="Editor-Smiles-List__item">🛎️</li>
    <li class="Editor-Smiles-List__item">🧳</li>
    <li class="Editor-Smiles-List__item">⌛</li>
    <li class="Editor-Smiles-List__item">⏳</li>
    <li class="Editor-Smiles-List__item">⌚</li>
    <li class="Editor-Smiles-List__item">⏰</li>
    <li class="Editor-Smiles-List__item">⏱️</li>
    <li class="Editor-Smiles-List__item">⏲️</li>
    <li class="Editor-Smiles-List__item">🕰️</li>
    <li class="Editor-Smiles-List__item">🌡️</li>
    <li class="Editor-Smiles-List__item">⛱️</li>
    <li class="Editor-Smiles-List__item">🧨</li>
    <li class="Editor-Smiles-List__item">🎈</li>
    <li class="Editor-Smiles-List__item">🎉</li>
    <li class="Editor-Smiles-List__item">🎊</li>
    <li class="Editor-Smiles-List__item">🎎</li>
    <li class="Editor-Smiles-List__item">🎏</li>
    <li class="Editor-Smiles-List__item">🎐</li>
    <li class="Editor-Smiles-List__item">🧧</li>
    <li class="Editor-Smiles-List__item">🎀</li>
    <li class="Editor-Smiles-List__item">🎁</li>
    <li class="Editor-Smiles-List__item">🤿</li>
    <li class="Editor-Smiles-List__item">🪀</li>
    <li class="Editor-Smiles-List__item">🪁</li>
    <li class="Editor-Smiles-List__item">🔮</li>
    <li class="Editor-Smiles-List__item">🧿</li>
    <li class="Editor-Smiles-List__item">🕹️</li>
    <li class="Editor-Smiles-List__item">🧸</li>
    <li class="Editor-Smiles-List__item">🖼️</li>
    <li class="Editor-Smiles-List__item">🧵</li>
    <li class="Editor-Smiles-List__item">🧶</li>
    <li class="Editor-Smiles-List__item">🛍️</li>
    <li class="Editor-Smiles-List__item">📿</li>
    <li class="Editor-Smiles-List__item">💎</li>
    <li class="Editor-Smiles-List__item">📯</li>
    <li class="Editor-Smiles-List__item">🎙️</li>
    <li class="Editor-Smiles-List__item">🎚️</li>
    <li class="Editor-Smiles-List__item">🎛️</li>
    <li class="Editor-Smiles-List__item">📻</li>
    <li class="Editor-Smiles-List__item">🪕</li>
    <li class="Editor-Smiles-List__item">📱</li>
    <li class="Editor-Smiles-List__item">☎️</li>
    <li class="Editor-Smiles-List__item">📞</li>
    <li class="Editor-Smiles-List__item">📟</li>
    <li class="Editor-Smiles-List__item">📠</li>
    <li class="Editor-Smiles-List__item">🔋</li>
    <li class="Editor-Smiles-List__item">🔌</li>
    <li class="Editor-Smiles-List__item">💻</li>
    <li class="Editor-Smiles-List__item">🖥️</li>
    <li class="Editor-Smiles-List__item">🖨️</li>
    <li class="Editor-Smiles-List__item">⌨️</li>
    <li class="Editor-Smiles-List__item">🖱️</li>
    <li class="Editor-Smiles-List__item">🖲️</li>
    <li class="Editor-Smiles-List__item">💽</li>
    <li class="Editor-Smiles-List__item">💾</li>
    <li class="Editor-Smiles-List__item">💿</li>
    <li class="Editor-Smiles-List__item">📀</li>
    <li class="Editor-Smiles-List__item">🧮</li>
    <li class="Editor-Smiles-List__item">🎥</li>
    <li class="Editor-Smiles-List__item">🎞️</li>
    <li class="Editor-Smiles-List__item">📽️</li>
    <li class="Editor-Smiles-List__item">📺</li>
    <li class="Editor-Smiles-List__item">📷</li>
    <li class="Editor-Smiles-List__item">📹</li>
    <li class="Editor-Smiles-List__item">📼</li>
    <li class="Editor-Smiles-List__item">🔍</li>
    <li class="Editor-Smiles-List__item">🔎</li>
    <li class="Editor-Smiles-List__item">🕯️</li>
    <li class="Editor-Smiles-List__item">💡</li>
    <li class="Editor-Smiles-List__item">🔦</li>
    <li class="Editor-Smiles-List__item">🏮</li>
    <li class="Editor-Smiles-List__item">🪔</li>
    <li class="Editor-Smiles-List__item">📔</li>
    <li class="Editor-Smiles-List__item">📕</li>
    <li class="Editor-Smiles-List__item">📗</li>
    <li class="Editor-Smiles-List__item">📚</li>
    <li class="Editor-Smiles-List__item">📓</li>
    <li class="Editor-Smiles-List__item">📰</li>
    <li class="Editor-Smiles-List__item">🗞️</li>
    <li class="Editor-Smiles-List__item">📑</li>
    <li class="Editor-Smiles-List__item">🔖</li>
    <li class="Editor-Smiles-List__item">🏷️</li>
    <li class="Editor-Smiles-List__item">💰</li>
    <li class="Editor-Smiles-List__item">💴</li>
    <li class="Editor-Smiles-List__item">💵</li>
    <li class="Editor-Smiles-List__item">💶</li>
    <li class="Editor-Smiles-List__item">💷</li>
    <li class="Editor-Smiles-List__item">💸</li>
    <li class="Editor-Smiles-List__item">✒️</li>
    <li class="Editor-Smiles-List__item">📮</li>
    <li class="Editor-Smiles-List__item">✉️</li>
    <li class="Editor-Smiles-List__item">📧</li>
    <li class="Editor-Smiles-List__item">📨</li>
    <li class="Editor-Smiles-List__item">📦</li>
    <li class="Editor-Smiles-List__item">🖋️</li>
    <li class="Editor-Smiles-List__item">🖊️</li>
    <li class="Editor-Smiles-List__item">🖌️</li>
    <li class="Editor-Smiles-List__item">🖍️</li>
    <li class="Editor-Smiles-List__item">📝</li>
    <li class="Editor-Smiles-List__item">📁</li>
    <li class="Editor-Smiles-List__item">📂</li>
    <li class="Editor-Smiles-List__item">📅</li>
    <li class="Editor-Smiles-List__item">📆</li>
    <li class="Editor-Smiles-List__item">🗓️</li>
    <li class="Editor-Smiles-List__item">📈</li>
    <li class="Editor-Smiles-List__item">📉</li>
    <li class="Editor-Smiles-List__item">📊</li>
    <li class="Editor-Smiles-List__item">📌</li>
    <li class="Editor-Smiles-List__item">📍</li>
    <li class="Editor-Smiles-List__item">✂️</li>
    <li class="Editor-Smiles-List__item">📐</li>
    <li class="Editor-Smiles-List__item">📏</li>
    <li class="Editor-Smiles-List__item">🗃️</li>
    <li class="Editor-Smiles-List__item">🔒</li>
    <li class="Editor-Smiles-List__item">🔑</li>
    <li class="Editor-Smiles-List__item">🔨</li>
    <li class="Editor-Smiles-List__item">🪓</li>
    <li class="Editor-Smiles-List__item">⛏️</li>
    <li class="Editor-Smiles-List__item">⚒️</li>
    <li class="Editor-Smiles-List__item">🛠️</li>
    <li class="Editor-Smiles-List__item">🗡️</li>
    <li class="Editor-Smiles-List__item">⚔️</li>
    <li class="Editor-Smiles-List__item">🔫</li>
    <li class="Editor-Smiles-List__item">🛡️</li>
    <li class="Editor-Smiles-List__item">🔧</li>
    <li class="Editor-Smiles-List__item">🧲</li>
    <li class="Editor-Smiles-List__item">⚖️</li>
    <li class="Editor-Smiles-List__item">🔗</li>
    <li class="Editor-Smiles-List__item">⚗️</li>
    <li class="Editor-Smiles-List__item">🧪</li>
    <li class="Editor-Smiles-List__item">🧬</li>
    <li class="Editor-Smiles-List__item">🔬</li>
    <li class="Editor-Smiles-List__item">🔭</li>
    <li class="Editor-Smiles-List__item">📡</li>
    <li class="Editor-Smiles-List__item">💉</li>
    <li class="Editor-Smiles-List__item">💊</li>
    <li class="Editor-Smiles-List__item">🩹</li>
    <li class="Editor-Smiles-List__item">🩺</li>
    <li class="Editor-Smiles-List__item">🚪</li>
    <li class="Editor-Smiles-List__item">🛏️</li>
    <li class="Editor-Smiles-List__item">🛋️</li>
    <li class="Editor-Smiles-List__item">🪑</li>
    <li class="Editor-Smiles-List__item">🚽</li>
    <li class="Editor-Smiles-List__item">🚿</li>
    <li class="Editor-Smiles-List__item">🛁</li>
    <li class="Editor-Smiles-List__item">🪒</li>
    <li class="Editor-Smiles-List__item">🧴</li>
    <li class="Editor-Smiles-List__item">🧷</li>
    <li class="Editor-Smiles-List__item">🧹</li>
    <li class="Editor-Smiles-List__item">🧺</li>
    <li class="Editor-Smiles-List__item">🧻</li>
    <li class="Editor-Smiles-List__item">🧼</li>
    <li class="Editor-Smiles-List__item">🧽</li>
    <li class="Editor-Smiles-List__item">🧯</li>
    <li class="Editor-Smiles-List__item">🚬</li>
    <li class="Editor-Smiles-List__item">🛒</li>
  </ul>
</template>

<script setup>
  import { defineProps } from 'vue';
  import { Props } from '../scripts/blockProps.js';
  //--------------------------
  const props = defineProps(Props()); 
  const emit = defineEmits();
  //--------------------------
  //Отправить найденный смайлик
  const chooseSmile = (e) => {
    const target = e.target;
    if(!target.closest('.Editor-Smiles-List__item')) return;
    emit('smile', target.textContent);
  }
 
</script>

<styles lang="scss">
  @import "../styles/Editor-Smiles-List.scss";
</styles>